// Vestaluna — scripts propios (vanilla JS, sin librerías externas)

function vlInitReveals() {
  // Secciones de la ficha que aparecen al bajar (encargo animaciones, 30 sep).
  document.querySelectorAll('.vl-historia__bloque,.vl-extra__bloque,.vlv__cab,.vl-extra__detalle,.vl-extra__paso').forEach((e) => e.classList.add('vl-reveal'));
  const els = document.querySelectorAll('.vl-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('vl-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const n = [...el.parentElement.children].filter((h) => h.classList.contains('vl-reveal')).indexOf(el);
          const delay = Math.min(n, 8) * 50;
          setTimeout(() => entry.target.classList.add('vl-visible'), delay);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  els.forEach((el) => obs.observe(el));
}

function vlInitAcordeones() {
  document.querySelectorAll('.vl-acordeon').forEach((ac) => {
    const boton = ac.querySelector('.vl-acordeon__boton');
    const panel = ac.querySelector('.vl-acordeon__panel');
    if (!boton || !panel) return;
    if (ac.dataset.vlAbierto === 'true') {
      ac.classList.add('vl-abierto');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      boton.setAttribute('aria-expanded', 'true');
    } else {
      boton.setAttribute('aria-expanded', 'false');
    }
    boton.addEventListener('click', () => {
      const abierto = ac.classList.toggle('vl-abierto');
      panel.style.maxHeight = abierto ? panel.scrollHeight + 'px' : '0px';
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  });
}

/* Formato de dinero. Usa el mismo formato que tiene puesto la tienda, que es
   el que aplica el filtro `money` de Liquid. Antes esto usaba toLocaleString,
   que en español pone el símbolo detrás, así que el precio pintado por Liquid
   y el pintado por JS no coincidían en la misma pantalla. Si un día se cambia
   el formato en Configuración → Detalles de la tienda, todo se mueve a la vez
   sin tocar código. */
function vlPrecioEspanol(centimos) {
  const partes = ((Number(centimos) || 0) / 100).toFixed(2).split('.');
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return partes.join(',') + ' \u20ac';
}

function vlFormatoDinero(centimos) {
  const formato = window.vlFormatoMoneda;
  const valor = Number(centimos) || 0;
  if (!formato) {
    return (valor / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
    });
  }
  function conMiles(separadorMiles, separadorDecimal, decimales) {
    const partes = (valor / 100).toFixed(decimales).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadorMiles);
    return partes.join(separadorDecimal);
  }
  return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, (todo, clave) => {
    switch (clave) {
      case 'amount':
        return conMiles(',', '.', 2);
      case 'amount_no_decimals':
        return conMiles(',', '.', 0);
      case 'amount_with_comma_separator':
        return conMiles('.', ',', 2);
      case 'amount_no_decimals_with_comma_separator':
        return conMiles('.', ',', 0);
      case 'amount_with_apostrophe_separator':
        return conMiles("'", '.', 2);
      case 'amount_no_decimals_with_space_separator':
        return conMiles(' ', ',', 0);
      case 'amount_with_space_separator':
        return conMiles(' ', ',', 2);
      default:
        return conMiles(',', '.', 2);
    }
  });
}

/* Deja el precio, el tachado y la cuota de Klarna acordes con lo que esté
   marcado en el selector de pack. Se llama tanto al cambiar de variante como
   al cambiar de opción del pack, para que manden los dos sin pisarse. */
function vlAplicarPack() {
  const precioEl = document.querySelector('[data-vl-precio]');
  const comparadoEl = document.querySelector('[data-vl-precio-comparado]');
  const klarna = document.querySelector('[data-vl-klarna]');
  const barraPrecio = document.querySelector('[data-vl-barra-precio]');
  const pack = document.querySelector('fieldset[data-vl-pack]');
  const form = document.querySelector('form[data-vl-producto-form]');
  const esPack = !!pack && !!form && form.dataset.vlPack === 'dos';

  let mostrado = precioEl ? precioEl.dataset.vlUnidad || precioEl.textContent : '';
  let centimos = precioEl ? Number(precioEl.dataset.vlUnidadCentimos) : 0;
  let tachado = comparadoEl ? comparadoEl.dataset.vlUnidad || '' : '';

  if (esPack) {
    mostrado = pack.dataset.vlPackPrecio;
    centimos = Number(pack.dataset.vlPackCentimos);
    tachado = pack.dataset.vlPackAntes;
  }

  if (precioEl && mostrado && precioEl.textContent !== mostrado) {
    if (precioEl.dataset.vlPintado && vlMueve()) precioEl.parentElement.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'cubic-bezier(0.2,0,0,1)' });
    precioEl.textContent = mostrado;
  }
  if (precioEl) precioEl.dataset.vlPintado = '1';
  if (comparadoEl) {
    comparadoEl.textContent = tachado;
    comparadoEl.style.display = tachado ? '' : 'none';
  }
  if (klarna && klarna.dataset.vlKlarnaPlantilla && centimos) {
    klarna.textContent = klarna.dataset.vlKlarnaPlantilla.replace(
      '[cuota]',
      vlFormatoDinero(Math.round(centimos / 3))
    );
  }
  // La barra fija escribe el precio a la española («49,95 €»), sin código de moneda.
  if (barraPrecio && centimos) barraPrecio.textContent = vlPrecioEspanol(centimos);
  else if (barraPrecio && mostrado) barraPrecio.textContent = mostrado;
  vlRefrescarBarra();
}

function vlInitVariantes() {
  document.querySelectorAll('[data-vl-producto-form]').forEach((wrap) => {
    const datos = wrap.querySelector('[data-vl-variantes]');
    if (!datos) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      return;
    }
    const inputId = wrap.querySelector('input[name="id"]');
    const precioEl = wrap.querySelector('[data-vl-precio]');
    const precioComparado = wrap.querySelector('[data-vl-precio-comparado]');
    const estadoEl = wrap.querySelector('[data-vl-estado]');
    const botonComprar = wrap.querySelector('[data-vl-boton-comprar]');
    const grupos = Array.from(wrap.querySelectorAll('[data-vl-opcion]'));
    const seleccion = grupos.map((grupo) => {
      const activo = grupo.querySelector('.vl-activa');
      return activo ? activo.dataset.vlValor : null;
    });

    const formatoDinero = vlFormatoDinero;

    function actualizar(inicial) {
      // La talla no viene marcada al entrar. Mientras falte, se enseña el
      // precio y la foto de la primera variante que encaje con lo elegido,
      // pero el botón pide la talla y el formulario no se envía.
      const completa = seleccion.every((v) => v !== null);
      let variante = variantes.find((v) => v.options.every((val, i) => seleccion[i] === val));
      if (!completa) {
        variante = variantes.find((v) => v.options.every((val, i) => seleccion[i] === null || seleccion[i] === val));
      }
      if (!variante) {
        if (botonComprar) {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.dataset.vlTextoAgotado;
        }
        if (estadoEl) estadoEl.textContent = wrap.dataset.vlTextoAgotadoAyuda || '';
        return;
      }
      if (inputId && completa) inputId.value = variante.id;

      // Cuota de pago a plazos: mismo cálculo que hace Liquid al pintar
      const klarna = document.querySelector('[data-vl-klarna]');
      if (klarna && klarna.dataset.vlKlarnaPlantilla) {
        klarna.textContent = klarna.dataset.vlKlarnaPlantilla.replace(
          '[cuota]',
          formatoDinero(Math.round(variante.price / 3))
        );
      }
      // Los importes de la variante se guardan en el propio elemento: si el
      // pack está marcado los tapa, y al volver a «1 body» hay que poder
      // restituirlos sin recargar ni volver a buscar la variante.
      if (precioEl) {
        precioEl.dataset.vlUnidad = formatoDinero(variante.price);
        precioEl.dataset.vlUnidadCentimos = variante.price;
      }
      if (precioComparado) {
        const hayTachado = variante.compare_at_price && variante.compare_at_price > variante.price;
        precioComparado.dataset.vlUnidad = hayTachado ? formatoDinero(variante.compare_at_price) : '';
      }
      vlAplicarPack();
      // El nombre del color elegido, junto a la etiqueta de la opcion
      grupos.forEach((grupo, i) => {
        const eco = grupo.querySelector('[data-vl-opcion-elegido]');
        if (eco && seleccion[i]) eco.textContent = '— ' + seleccion[i];
      });

      // La foto de la variante elegida pasa la primera de la rejilla, pero
      // solo cuando la clienta cambia de color: al cargar manda el orden de
      // la galería (la 1.ª es la escena elegida, 30 sep).
      if (variante.media && !inicial) {
        const fotos = document.querySelectorAll('.vl-producto__foto[data-vl-media]');
        let alguna = false;
        fotos.forEach((f) => {
          const suya = String(f.dataset.vlMedia) === String(variante.media);
          if (suya) alguna = true;
          f.style.order = suya ? '-2' : '';
          f.classList.toggle('vl-producto__foto--activa', suya);
          if (suya && window.vlCine) window.vlCine(f.querySelector('img'), true);
        });
        // La línea de la modelo se queda justo debajo de la foto principal
        const modelo = document.querySelector('[data-vl-modelo]');
        if (modelo) modelo.style.order = alguna ? '-1' : '';
      }

      if (!botonComprar) return;
      if (!completa) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.dataset.vlTextoElige || 'Elige tu talla';
        if (estadoEl) estadoEl.textContent = '';
        vlRefrescarBarra();
        return;
      }
      if (variante.available) {
        botonComprar.disabled = false;
        vlRueda(botonComprar, botonComprar.dataset.vlTextoDisponible);
        if (estadoEl) estadoEl.textContent = '';
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.dataset.vlTextoAgotado;
        if (estadoEl) estadoEl.textContent = wrap.dataset.vlTextoAgotadoAyuda || '';
      }
    }

    wrap.querySelectorAll('[data-vl-valor]').forEach((boton) => {
      boton.addEventListener('click', () => {
        const grupo = boton.closest('[data-vl-opcion]');
        grupo.querySelectorAll('[data-vl-valor]').forEach((b) => b.classList.remove('vl-activa'));
        boton.classList.add('vl-activa');
        seleccion[grupos.indexOf(grupo)] = boton.dataset.vlValor;
        actualizar();
      });
    });

    actualizar(true);
  });
}

function vlInitCantidad() {
  document.querySelectorAll('[data-vl-cantidad]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const delta = Number(btn.dataset.vlDelta);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });
  });
}

/* Añadir al carrito sin salir de la ficha: se abre el cajón del carrito.
   Si el tema no tiene cajón (o falla fetch), el formulario se envía como
   siempre y Shopify lleva a /cart. */
function vlInitCarritoAjax() {
  document.querySelectorAll('form[data-vl-producto-form]').forEach((form) => {
    if (form.dataset.vlAjaxListo) return;
    form.dataset.vlAjaxListo = '1';
    form.addEventListener('submit', (evt) => {
      // Sin talla elegida no se añade nada: se lleva a la clienta al selector.
      if (vlTallaElegida() === '') {
        evt.preventDefault();
        vlPedirTalla(form);
        return;
      }
      const cajon = document.querySelector('cart-drawer');
      if (!cajon || typeof cajon.renderContents !== 'function' || !window.fetch || !window.FormData) return;
      evt.preventDefault();
      const boton = form.querySelector('[data-vl-boton-comprar]');
      const estado = form.querySelector('[data-vl-estado]');

      // Con el pack elegido va una sola llamada con las dos variantes de la
      // talla. Sin pack, el envío es el de siempre y no cambia nada.
      let destino = form.getAttribute('action') || '/cart/add';
      let cabeceras = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' };
      let cuerpo;
      if (form.dataset.vlPack === 'dos') {
        const pareja = vlParejaPack(form);
        if (!pareja) {
          if (estado) estado.textContent = form.dataset.vlTextoAgotadoAyuda || '';
          return;
        }
        // Las propiedades de línea del formulario (el envío) viajan también con
        // el pack: si no, los dos artículos del pack serían los únicos del
        // catálogo que llegan al resumen del pedido sin la línea de envío.
        const propiedades = {};
        form.querySelectorAll('input[name^="properties["]').forEach((campo) => {
          const nombre = campo.name.match(/^properties\[(.+)\]$/);
          if (nombre && campo.value) propiedades[nombre[1]] = campo.value;
        });
        destino = '/cart/add.js';
        cabeceras = Object.assign({ 'Content-Type': 'application/json' }, cabeceras);
        cuerpo = JSON.stringify({
          items: pareja.map((id) => ({ id: id, quantity: 1, properties: propiedades })),
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        });
      } else {
        const datos = new FormData(form);
        datos.append('sections', 'cart-drawer,cart-icon-bubble');
        datos.append('sections_url', window.location.pathname);
        cuerpo = datos;
      }

      if (boton) {
        boton.disabled = true;
        boton.setAttribute('aria-busy', 'true');
      }
      fetch(destino, {
        method: 'POST',
        headers: cabeceras,
        body: cuerpo,
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            if (estado) estado.textContent = res.description || res.message || '';
            return;
          }
          if (estado) estado.textContent = '';
          // El popup de bienvenida no sale a quien ya ha añadido algo en esta visita.
          try { sessionStorage.setItem('vl_anadido', '1'); } catch (e) {}
          if (boton) {
            const antes = boton.textContent;
            const fundido = () => vlMueve() && boton.animate([{ opacity: 0.3 }, { opacity: 1 }], { duration: 200 });
            boton.textContent = 'Añadido';
            fundido();
            setTimeout(() => { boton.textContent = antes; fundido(); vlRefrescarBarra(); }, 1200);
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            // Con el pack la respuesta trae items[] en vez de variant_id suelto.
            const idVariante = res.variant_id || (res.items && res.items[0] && res.items[0].variant_id);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: idVariante, cartData: res });
          }
          return vlVuela(boton).then(() => {
            cajon.classList.remove('is-empty');
            cajon.renderContents(res);
            setTimeout(vlPintarFechas, 0);
          });
        })
        .catch(() => {
          form.submit();
        })
        .finally(() => {
          if (boton) {
            boton.disabled = false;
            boton.removeAttribute('aria-busy');
          }
        });
    });
  });
}

/* Marca en <html> que el cajón del carrito está abierto. Lo usa el CSS para
   esconder la capa de Shopify Forms mientras dure: esa capa se pinta con
   z-index 2147483647, el máximo posible, así que ninguna regla de z-index la
   gana y se queda por encima del cajón comiéndose el toque en «Pagar pedido».
   Solo se oculta mientras el cajón está abierto; al cerrarlo vuelve y su
   lógica de «ya visto» no se toca. Va en todas las páginas porque el cajón
   también. */
function vlInitCajonAbierto() {
  const cajon = document.querySelector('cart-drawer');
  if (!cajon || typeof MutationObserver === 'undefined') return;
  const marcar = () => {
    document.documentElement.classList.toggle('vl-cajon-abierto', cajon.classList.contains('active'));
  };
  new MutationObserver(marcar).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  marcar();
}

/* Talla elegida ahora mismo, leída de los botones del selector. Devuelve
   cadena vacía si no hay ninguna marcada. */
/* Devuelve la talla elegida, '' si hay selector de talla y no se ha elegido,
   y null si el producto no tiene talla (la mochila): entonces la barra fija
   compra directamente, sin pedir talla. */
function vlTallaElegida() {
  let talla = null;
  document.querySelectorAll('[data-vl-opcion]').forEach((grupo) => {
    if ((grupo.getAttribute('data-vl-opcion') || '').toLowerCase().indexOf('talla') === -1) return;
    if (talla === null) talla = '';
    const activa = grupo.querySelector('.vl-activa[data-vl-valor]');
    if (activa) talla = activa.getAttribute('data-vl-valor');
  });
  return talla;
}

/* Lleva al selector de talla y lo marca un momento. Lo usan el botón real y
   la barra fija cuando todavía no hay talla elegida. */
function vlPedirTalla(form) {
  const grupo = [...document.querySelectorAll('[data-vl-opcion]')]
    .find((g) => (g.getAttribute('data-vl-opcion') || '').toLowerCase().indexOf('talla') !== -1);
  const estado = form && form.querySelector('[data-vl-estado]');
  if (estado) estado.textContent = 'Elige tu talla para continuar.';
  if (!grupo) return;
  grupo.scrollIntoView({ behavior: 'smooth', block: 'center' });
  grupo.classList.remove('vl-producto__opcion--aviso');
  void grupo.offsetWidth;
  grupo.classList.add('vl-producto__opcion--aviso');
}

/* Refresca el rótulo de la barra fija. Lo llaman el selector de variante y
   los propios clics en las tallas. */
/* Selector de pack de dos unidades. Solo existe en la ficha cuya plantilla
   lleva el bloque «pack»; en las demás no hay nada que enganchar y la función
   sale sin hacer nada. Al elegir «los dos» se bloquea el selector de color,
   porque el pack son los dos colores fijos, y la talla sigue mandando. El
   descuento NO se calcula aquí: lo aplica el descuento automático de Shopify
   cuando ve dos unidades del producto en el carrito. */
function vlInitPack() {
  document.querySelectorAll('fieldset[data-vl-pack]').forEach((pack) => {
    if (pack.dataset.vlPackListo) return;
    pack.dataset.vlPackListo = '1';
    const form = document.querySelector('form[data-vl-producto-form]');
    if (!form) return;
    const nota = pack.querySelector('[data-vl-pack-nota]');
    const grupoColor = form.querySelector('[data-vl-opcion="' + pack.dataset.vlPackOpcion + '"]');
    // Colores libres (bloque con pack_colores_libres): dos filas de muestras,
    // una por unidad. Sin la casilla no existen y todo sigue como antes.
    const colores = pack.hasAttribute('data-vl-pack-libre') ? pack.querySelector('[data-vl-pack-colores]') : null;
    const elegirMuestra = (fila, boton) => {
      fila.querySelectorAll('[data-vl-pack-muestra]').forEach((b) => {
        b.classList.toggle('vl-activa', b === boton);
        b.setAttribute('aria-pressed', b === boton ? 'true' : 'false');
      });
      const rotulo = fila.querySelector('[data-vl-pack-color-elegido]');
      if (rotulo) rotulo.textContent = '\u2014 ' + boton.dataset.vlPackMuestra;
    };
    if (colores) {
      colores.querySelectorAll('[data-vl-pack-color]').forEach((fila) => {
        fila.querySelectorAll('[data-vl-pack-muestra]').forEach((boton) => {
          boton.addEventListener('click', () => {
            fila.dataset.vlTocada = '1';
            elegirMuestra(fila, boton);
            const estado = form.querySelector('[data-vl-estado]');
            if (estado) estado.textContent = '';
          });
        });
      });
    }

    function marcar() {
      const elegido = pack.querySelector('[data-vl-pack-radio]:checked');
      const esPack = !!elegido && elegido.value === 'dos';
      pack.querySelectorAll('[data-vl-pack-tarjeta]').forEach((tarjeta) => {
        const suya = tarjeta.dataset.vlPackTarjeta === (esPack ? 'dos' : 'uno');
        tarjeta.classList.toggle('vl-pack__opcion--elegida', suya);
      });
      if (nota) nota.hidden = !esPack;
      if (colores) {
        colores.hidden = !esPack;
        // Hasta que la clienta toque una fila, las dos parten del color que
        // tenga elegido arriba.
        const activo = grupoColor ? grupoColor.querySelector('.vl-activa[data-vl-valor]') : null;
        if (esPack && activo) {
          colores.querySelectorAll('[data-vl-pack-color]').forEach((fila) => {
            if (fila.dataset.vlTocada) return;
            const igual = Array.from(fila.querySelectorAll('[data-vl-pack-muestra]'))
              .find((b) => b.dataset.vlPackMuestra === activo.dataset.vlValor);
            if (igual) elegirMuestra(fila, igual);
          });
        }
      }
      // Con el pack la cantidad no pinta nada (siempre van dos): se oculta y
      // vuelve a 1, para que nunca parezca que se piden 3 y lleguen 2.
      const cantidad = form.querySelector('[data-vl-cantidad]');
      if (cantidad) {
        cantidad.hidden = esPack;
        const campo = cantidad.querySelector('input');
        if (esPack && campo) campo.value = 1;
      }
      // Con el pack el color se elige en sus dos filas: el de arriba se oculta.
      if (grupoColor) grupoColor.hidden = esPack;
      form.dataset.vlPack = esPack ? 'dos' : 'uno';
      vlAplicarPack();
    }

    pack.querySelectorAll('[data-vl-pack-radio]').forEach((radio) => {
      radio.addEventListener('change', marcar);
    });
    marcar();
  });
}

/* Las dos variantes del pack para la talla que esté elegida. Devuelve null si
   falta la talla o si una de las dos no está disponible: entonces no se añade
   nada, igual que cuando no hay variante. */
function vlParejaPack(form) {
  const pack = document.querySelector('fieldset[data-vl-pack]');
  const datos = form.querySelector('[data-vl-variantes]');
  if (!pack || !datos) return null;
  let variantes;
  try {
    variantes = JSON.parse(datos.textContent);
  } catch (e) {
    return null;
  }
  const grupos = Array.from(form.querySelectorAll('[data-vl-opcion]'));
  const nombres = grupos.map((g) => g.dataset.vlOpcion);
  const valores = grupos.map((g) => {
    const activo = g.querySelector('.vl-activa');
    return activo ? activo.dataset.vlValor : null;
  });
  const iColor = nombres.indexOf(pack.dataset.vlPackOpcion);
  if (iColor < 0) return null;
  for (let i = 0; i < valores.length; i += 1) {
    if (i !== iColor && !valores[i]) return null;
  }
  const buscar = (color) =>
    variantes.find((v) => v.options.every((val, i) => (i === iColor ? val === color : valores[i] === val)));
  let colorA = pack.dataset.vlPackValorA;
  let colorB = pack.dataset.vlPackValorB;
  if (pack.hasAttribute('data-vl-pack-libre')) {
    const elegido = (n) => {
      const boton = pack.querySelector('[data-vl-pack-color="' + n + '"] .vl-activa[data-vl-pack-muestra]');
      return boton ? boton.dataset.vlPackMuestra : null;
    };
    colorA = elegido(1);
    colorB = elegido(2);
    if (!colorA || !colorB) return null;
  }
  const a = buscar(colorA);
  const b = buscar(colorB);
  if (!a || !b || !a.available || !b.available) return null;
  return [a.id, b.id];
}

function vlRefrescarBarra() {
  const barra = document.querySelector('[data-vl-barra]');
  if (!barra) return;
  const talla = vlTallaElegida();
  const rotulo = barra.querySelector('[data-vl-barra-talla]');
  const boton = barra.querySelector('[data-vl-barra-boton]');
  const real = document.querySelector('[data-vl-boton-comprar]');
  if (rotulo) rotulo.textContent = talla ? 'Talla ' + talla : '';
  if (boton && real) {
    const lista = talla !== '';
    boton.textContent = lista ? real.textContent.trim() : 'Elige tu talla';
    boton.disabled = lista ? real.disabled : false;
  }
}

/* Barra de compra fija (móvil y escritorio). En escritorio se enseña cuando el
   botón real no está a la vista. En el móvil (hasta 767 px, como el CSS) solo
   cuando el botón ya ha quedado por encima de la pantalla: al cargar no sale y
   no tapa la frase de debajo del título (7 oct). En los dos se esconde si
   asoma el pie o si se abre el cajón. El botón no añade nada por su cuenta:
   envía el mismo formulario. */
function vlInitBarraCompra() {
  const barra = document.querySelector('[data-vl-barra]');
  const real = document.querySelector('[data-vl-boton-comprar]');
  const form = document.querySelector('form[data-vl-producto-form]');
  if (!barra || !real || !form || typeof IntersectionObserver === 'undefined') return;

  const movil = window.matchMedia('(max-width: 767px)');
  let botonALaVista = true;
  let botonEncima = false;
  let pieALaVista = false;
  let cajonAbierto = false;

  function refrescar() {
    const fuera = movil.matches ? botonEncima : !botonALaVista;
    const mostrar = fuera && !pieALaVista && !cajonAbierto;
    barra.classList.toggle('vl-barra--visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
  }

  // El botón cuenta como «a la vista» solo si se ve casi entero: si asoma un
  // borde por abajo (pasa a 1366×768 en escritorio), la barra ya sale.
  new IntersectionObserver((e) => {
    botonALaVista = e[0].intersectionRatio >= 0.9;
    botonEncima = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
    refrescar();
  }, { threshold: [0, 0.9, 1] }).observe(real);
  if (movil.addEventListener) movil.addEventListener('change', refrescar);
  const pie = document.querySelector('.vl-footer');
  if (pie) new IntersectionObserver((e) => { pieALaVista = e[0].isIntersecting; refrescar(); }, { threshold: 0 }).observe(pie);

  const cajon = document.querySelector('cart-drawer');
  if (cajon && typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => {
      cajonAbierto = cajon.classList.contains('active');
      refrescar();
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  }

  barra.querySelector('[data-vl-barra-boton]').addEventListener('click', () => {
    if (vlTallaElegida() === '') {
      vlPedirTalla(form);
      return;
    }
    if (real.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(real);
    else real.click();
  });

  document.querySelectorAll('[data-vl-opcion] [data-vl-valor]').forEach((b) => {
    b.addEventListener('click', () => setTimeout(vlRefrescarBarra, 0));
  });
  vlRefrescarBarra();
  refrescar();
}

/* Con el aviso de cookies de Shopify abierto la barra fija de compra no se
   enseña; sale al aceptarlo o rechazarlo (html.vl-aviso-abierto, lo usa el
   CSS). El aviso llega tarde, así que se mira cada 400 ms hasta que se va (o
   15 s si no sale). */
function vlInitBarraSobreAviso() {
  const raiz = document.documentElement;
  let visto = false;
  let vueltas = 0;
  const medir = () => {
    const aviso = document.getElementById('shopify-pc__banner');
    const abierto = !!(aviso && aviso.offsetHeight);
    raiz.classList.toggle('vl-aviso-abierto', abierto);
    return abierto;
  };
  const reloj = setInterval(() => {
    vueltas += 1;
    const abierto = medir();
    if (abierto) visto = true;
    if ((visto && !abierto) || (!visto && vueltas > 37)) clearInterval(reloj);
  }, 400);
  medir();
  document.addEventListener('visitorConsentCollected', () => setTimeout(medir, 50));
}

/* Guía de tallas en ventana modal. No duplica el texto: al abrir clona el
   bloque «Cómo elegir tu talla» que ya existe en la descripción, más su tabla
   de medidas si la hay. Si el navegador no soporta <dialog>, lleva al bloque. */
function vlInitGuiaTallas() {
  const dialogo = document.querySelector('[data-vl-guia]');
  const abridores = document.querySelectorAll('[data-vl-guia-abrir]');
  if (!dialogo || !abridores.length) return;
  const destino = dialogo.querySelector('[data-vl-guia-contenido]');

  function origen() {
    return document.querySelector('.vl-producto__talla-ayuda');
  }

  abridores.forEach((a) => {
    a.addEventListener('click', () => {
      const bloque = origen();
      if (!bloque) return;
      if (typeof dialogo.showModal !== 'function') {
        bloque.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      destino.innerHTML = '';
      destino.appendChild(bloque.cloneNode(true));
      const siguiente = bloque.nextElementSibling;
      if (siguiente && siguiente.tagName === 'TABLE') destino.appendChild(siguiente.cloneNode(true));
      dialogo.showModal();
      destino.scrollTop = 0;
    });
  });

  const cerrar = dialogo.querySelector('[data-vl-guia-cerrar]');
  if (cerrar) cerrar.addEventListener('click', () => dialogo.close());
  // Pulsar fuera de la caja cierra.
  dialogo.addEventListener('click', (evt) => { if (evt.target === dialogo) dialogo.close(); });
  // Escape. <dialog> debería cerrarlo solo, pero en pruebas no siempre lo hace
  // según dónde esté el foco, así que se cierra a mano y no se deja al azar.
  document.addEventListener('keydown', (evt) => {
    if ((evt.key === 'Escape' || evt.key === 'Esc') && dialogo.open) dialogo.close();
  });
}

/* Fecha de entrega. El HTML sale de snippets/fecha-entrega.liquid con un texto
   de reserva; aquí se sustituye por el texto con fechas. Se calcula en el
   navegador a propósito: Shopify cachea el HTML y una fecha escrita en Liquid
   se quedaría congelada. Días NATURALES, como dice la política de envío.
   Los nombres de día y mes van en arrays propios para que no dependan del
   idioma del dispositivo. Si algo falla, no se toca nada y queda la reserva.
   Desde el 8 oct, formato corto con mes en las dos fechas: «mié 14 oct».
   La ficha dice «Pídela» o «Pídelo» según data-vl-pide (lo pone el snippet
   según el nombre del producto). */
function vlPintarFechas() {
  const objetivos = document.querySelectorAll('[data-vl-entrega]');
  if (!objetivos.length) return;

  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const CORTOS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
    'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];

  // El «hoy» que cuenta es el de Madrid, no el del reloj del dispositivo.
  let hoy;
  try {
    const partes = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date());
    const v = {};
    partes.forEach((p) => { v[p.type] = p.value; });
    hoy = new Date(Date.UTC(Number(v.year), Number(v.month) - 1, Number(v.day)));
  } catch (e) {
    return;
  }
  if (!hoy || isNaN(hoy.getTime())) return;

  function suma(dias) {
    const f = new Date(hoy.getTime());
    f.setUTCDate(f.getUTCDate() + dias);
    return f;
  }
  function escribe(f, nombres, conMes) {
    return nombres[f.getUTCDay()] + ' ' + f.getUTCDate() + (conMes ? ' de ' + MESES[f.getUTCMonth()] : '');
  }

  // «mié 14 oct»
  function corta(f) {
    return CORTOS[f.getUTCDay()] + ' ' + f.getUTCDate() + ' ' + MESES_CORTOS[f.getUTCMonth()];
  }

  const min = suma(5);
  const max = suma(12);

  objetivos.forEach((el) => {
    const tipo = el.getAttribute('data-vl-entrega');
    if (tipo === 'ficha') {
      const pide = el.getAttribute('data-vl-pide') === 'la' ? 'Pídela' : 'Pídelo';
      el.innerHTML = pide + ' hoy y te llega entre el <strong>' + corta(min) +
        '</strong> y el <strong>' + corta(max) + '</strong>';
    } else if (tipo === 'ficha-fecha') {
      el.innerHTML = 'La mayoría de pedidos llegan antes del ' + escribe(max, DIAS, true) +
        '. Si lo necesitas para una fecha concreta, escríbenos a ' +
        '<a href="mailto:hola@vestaluna.com">hola@vestaluna.com</a>' +
        ' antes de comprar.';
    } else if (tipo === 'linea') {
      // Paso «llega a tu casa» de la línea de tiempo de la ficha.
      el.textContent = 'Entre el ' + corta(min) + ' y el ' + corta(max);
    } else if (tipo === 'carrito') {
      el.textContent = 'Pide hoy y te llega entre el ' + corta(min) + ' y el ' + corta(max);
    }
  });
}

/* El texto del botón «rueda» de «Elige tu talla» a «Añadir al carrito». */
function vlRueda(b, txt) {
  const antes = b.textContent.trim();
  if (antes === txt) return;
  if (!vlMueve() || antes !== (b.dataset.vlTextoElige || 'Elige tu talla')) { b.textContent = txt; return; }
  const s = document.createElement('span');
  s.className = 'vl-rueda'; s.textContent = txt; b.replaceChildren(s);
  s.animate([{ transform: 'translateY(110%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(0.2,0,0,1)' });
}

/* Añadir al carrito: la miniatura vuela en arco hasta el icono (600 ms) y el
   icono hace un pequeño «pop». Devuelve una promesa que se cumple al acabar. */
function vlVuela(desde) {
  return new Promise((fin) => {
    const icono = document.querySelector('#cart-icon-bubble');
    const foto = document.querySelector('.vl-producto__foto--activa img') || document.querySelector('.vl-producto__foto:first-of-type img');
    if (!vlMueve() || !icono || !foto || !desde) return fin();
    const barra = document.querySelector('.vl-barra--visible [data-vl-barra-boton]');
    let a = desde.getBoundingClientRect();
    if ((a.bottom < 0 || a.top > innerHeight) && barra) a = barra.getBoundingClientRect();
    const r = icono.getBoundingClientRect();
    const x0 = a.left + a.width / 2 - 32, y0 = a.top + a.height / 2 - 48;
    const x1 = (r.top > 0 ? r.left + r.width / 2 : innerWidth - 30) - 32, y1 = (r.top > 0 ? r.top + r.height / 2 : 24) - 48;
    const m = document.createElement('img');
    m.src = foto.currentSrc || foto.src; m.alt = '';
    m.style.cssText = 'position:fixed;left:0;top:0;width:64px;height:96px;object-fit:cover;z-index:2000;pointer-events:none;';
    document.body.appendChild(m);
    const k = [];
    for (let i = 0; i <= 6; i++) {
      const p = i / 6, x = x0 + (x1 - x0) * p, y = y0 + (y1 - y0) * p - Math.sin(Math.PI * p) * 140;
      k.push({ transform: `translate(${x}px,${y}px) scale(${1 - 0.65 * p})`, opacity: 1 - 0.3 * p, offset: p });
    }
    m.animate(k, { duration: 600, easing: 'cubic-bezier(0.2,0,0,1)' }).finished.then(() => {
      m.remove();
      icono.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(0.2,0,0,1)' });
      setTimeout(fin, 160);
    }, fin);
  });
}

/* GSAP (vl-cine.js) para la ficha: se pide cuando la 1.ª foto ya está cargada y
   la persona empieza a bajar (o la página se abre ya bajada). Nunca con «reducir
   movimiento» ni donde no hay nada que mover. Las URL las pone layout/theme.liquid. */
function vlCargaCine() {
  const u = window.vlCineUrls;
  if (!u || !vlMueve() || !document.querySelector('.vl-historia, [data-vl-giro], [data-vl-tanda-giro], [data-vl-anillo], .vl-mosaico__foto, .card__media, .vl-ficha__media, .vl-titulo-seccion')) return;
  const ev = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
  let ido = false;
  const va = (e) => {
    // Solo el scroll de la página: los carruseles (barra de anuncios, galería) también lanzan «scroll» y no cuentan.
    if (ido || (e && e.type === 'scroll' && e.target !== document)) return;
    ido = true;
    ev.forEach((t) => removeEventListener(t, va, true));
    u.forEach((src) => { const s = document.createElement('script'); s.src = src; s.async = false; document.head.appendChild(s); });
  };
  const arma = () => {
    ev.forEach((t) => addEventListener(t, va, { capture: true, passive: true }));
    if (scrollY > 40) va();
  };
  const primera = document.querySelector('.vl-producto__foto:first-of-type img');
  if (!primera || (primera.complete && primera.naturalWidth > 1)) arma();
  else { primera.addEventListener('load', arma, { once: true }); primera.addEventListener('error', arma, { once: true }); }
}

/* ¿Se puede animar? Con «reducir movimiento» no hay ninguna animación. */
function vlMueve() {
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/* Efectos que se disparan una sola vez al entrar en pantalla: acercamiento
   lento de las fotos de «Dónde llevarlo» y la pista del Sin/Con (el tirador
   va y vuelve para que se vea que se arrastra). Y la línea bajo la galería
   del móvil, que sigue la foto en la que estás. */
function vlInitEfectos() {
  const lin = document.querySelector('.vl-galeria-linea span');
  const gal = document.querySelector('.vl-producto__galeria');
  if (lin && gal) {
    const n = gal.querySelectorAll('.vl-producto__foto').length;
    lin.style.width = 100 / n + '%';
    let rq = 0;
    gal.addEventListener('scroll', () => {
      if (rq) return;
      rq = requestAnimationFrame(() => {
        rq = 0;
        const max = gal.scrollWidth - gal.clientWidth;
        lin.style.transform = 'translateX(' + (max > 0 ? (gal.scrollLeft / max) * (n - 1) * 100 : 0) + '%)';
      });
    }, { passive: true });
  }
  if (!vlMueve() || !window.IntersectionObserver) return;
  // Carrusel del móvil: la foto que entra se funde cuando ya está pintada (sin zoom).
  const cine = (img, funde) => {
    if (!img) return;
    const va = () => requestAnimationFrame(() => requestAnimationFrame(() => {
      img.classList.remove('vl-cine', 'vl-funde'); void img.offsetWidth;
      img.classList.add('vl-cine'); if (funde) img.classList.add('vl-funde');
    }));
    if (img.complete && img.naturalWidth > 1) va(); else img.addEventListener('load', va, { once: true });
  };
  if (gal && matchMedia('(max-width: 900px)').matches) {
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { vio.unobserve(e.target); cine(e.target.querySelector('img:not([src^="data:"])') || e.target.querySelector('img'), true); }
    }), { root: gal, threshold: 0.6 });
    gal.querySelectorAll('.vl-producto__foto:not(:first-of-type)').forEach((f) => vio.observe(f));
  }
  // Cortina (fotos al bajar), una sola vez. Las escenas de «Dónde llevarlo» y el Sin/Con los mueve vl-cine.js (GSAP).
  const obs = new IntersectionObserver((es) => {
    let i = 0;
    es.forEach((e) => {
      if (!e.isIntersecting) return;
      obs.unobserve(e.target);
      const c = e.target;
      c.style.setProperty('--vl-d', (i++ * 110) + 'ms');
      c.classList.add('vl-visto');
    });
  }, { threshold: 0, rootMargin: '0px 0px -12% 0px' }); // con la cortina cerrada el área visible es 0: se mira solo si entra
  document.querySelectorAll('.vl-historia__lado,.vl-ficha__media,.card__media,.vlv__marco,.vl-mosaico__foto').forEach((e) => obs.observe(e));
  // Brillo del botón: a los 2,5 s y cada 8 s, 3 veces como mucho; nunca tras pulsarlo.
  const bot = document.querySelector('[data-vl-boton-comprar]');
  if (bot) {
    let n = 0, reloj;
    const brilla = () => {
      if (bot.dataset.vlPulsado) return;
      bot.classList.remove('vl-brillo'); void bot.offsetWidth; bot.classList.add('vl-brillo');
      if (++n < 3) reloj = setTimeout(brilla, 8000);
    };
    reloj = setTimeout(brilla, 2500);
    document.querySelectorAll('[data-vl-boton-comprar],[data-vl-barra-boton]').forEach((x) => x.addEventListener('pointerdown', () => {
      bot.dataset.vlPulsado = 1; clearTimeout(reloj); bot.classList.remove('vl-brillo');
    }));
  }
}

/* Varias secciones vl-* incluyen este mismo archivo y el navegador lo ejecuta
   una vez por etiqueta <script>. La bandera evita registrar los manejadores
   más de una vez (si no, un clic en «Añadir al carrito» enviaba tres veces). */
if (!window.__vlInicializado) {
  window.__vlInicializado = true;

  document.addEventListener('DOMContentLoaded', () => {
    vlInitReveals();
    vlInitAcordeones();
    vlInitVariantes();
    vlInitPack();
    vlInitCantidad();
    vlInitCajonAbierto();
    vlInitCarritoAjax();
    vlPintarFechas();
    vlInitBarraCompra();
    vlInitBarraSobreAviso();
    vlInitGuiaTallas();
    vlInitEfectos();
    vlCargaCine();
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="/products/"]');
      const tarjeta = a && a.closest('.vl-ficha, .card-wrapper, .vl-producto__combina-ficha');
      const img = tarjeta && ([...tarjeta.querySelectorAll('img')].find((i) => parseFloat(getComputedStyle(i).opacity) > 0.5) || tarjeta.querySelector('img'));
      if (!img) return;
      document.querySelectorAll('.vl-producto__foto img').forEach((i) => { i.style.viewTransitionName = 'none'; });
      img.style.viewTransitionName = 'vl-foto';
    });
    addEventListener('pageshow', () => document.querySelectorAll('[style*="view-transition-name"]').forEach((i) => { i.style.viewTransitionName = ''; }));
  });

  // El cajón se vuelve a pintar entero con cada cambio del carrito, así que
  // el texto de reserva reaparece y hay que volver a escribir las fechas.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(vlPintarFechas, 0));
  }
}

/* No recomendar el producto que ya se está viendo */
if (!window.__vlRelacionadosInicializado) {
  window.__vlRelacionadosInicializado = true;
document.addEventListener('DOMContentLoaded', function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  document.querySelectorAll('.vl-productos__grid').forEach(function (grid) {
    var fichas = grid.querySelectorAll('a.vl-ficha');
    var fuera = 0;
    fichas.forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (href === '/products/' + m[1]) { a.remove(); fuera++; }
    });
    if (fuera) grid.style.setProperty('--vl-cols', Math.max(2, fichas.length - fuera));
  });
});
}
